import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import logger from '../../utils/logger';

const AuthGuard = ({ children }) => {
  const { user, setUser } = useAuth();
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const validateToken = async () => {
      try {
        // Check if user exists in context
        if (!user) {
          setIsValid(false);
          setIsValidating(false);
          return;
        }

        // Check if token exists in localStorage
        const token = localStorage.getItem('faithinsight_token');
        if (!token) {
          setIsValid(false);
          setIsValidating(false);
          return;
        }

        // Validate token with backend
        try {
          const response = await api.validateToken();
          if (response.success) {
            setIsValid(true);
          } else {
            // Clear invalid user data
            localStorage.removeItem('faithinsight_user');
            localStorage.removeItem('faithinsight_token');
            setUser(null);
            setIsValid(false);
          }
        } catch (error) {
          // If token validation fails (401, 403, etc.), clear user data
          if (error.status === 401 || error.status === 403) {
            localStorage.removeItem('faithinsight_user');
            localStorage.removeItem('faithinsight_token');
            setUser(null);
          }
          setIsValid(false);
        }
      } catch (error) {
        logger.error('Auth guard error', { error });
        setIsValid(false);
      } finally {
        setIsValidating(false);
      }
    };

    validateToken();
  }, [user, setUser]);

  // Show loading while validating
  if (isValidating) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.1rem',
        color: 'var(--text-muted)'
      }}>
        Validating authentication...
      </div>
    );
  }

  // Redirect to login if not valid
  if (!isValid) {
    return <Navigate to="/login" replace />;
  }

  // Render children if valid
  return children;
};

export default AuthGuard;
